// extracted by mini-css-extract-plugin
export var formContainer = "_k9-0";
export var message = "_k9-1";